import { round, sumBy } from "lodash";
import { Purchase } from "types";
import { SplitPayDemographics } from "./CreatePurchaseSplitPayTypes";

const calculateRoundingDiscrepancy = (amount: number, purchase: Purchase) => {
    const discrepancy = purchase.balance - amount;
    const isRoundOffAmountValid = !!discrepancy && Math.abs(discrepancy) < 0.1;

    if (isRoundOffAmountValid) {
        return round(discrepancy, 2);
    }

    return 0;
};

/**
 * Returns sum of all items in Split pay demographics with round-off discrepancy if applicable
 **/
export const getDemographicsTotalSum = (demographics: SplitPayDemographics, purchase: Purchase) => {
    let sum = 0;
    for (const object of demographics.items) {
        sum +=
            sumBy(object.splitPayItemValues.demographics, "amount") +
            sumBy(object.splitPayItemValues.addons, "amount") +
            object.splitPayItemValues.taxes;
    }

    return round(sum, 2) + calculateRoundingDiscrepancy(sum, purchase);
};

/**
 * Returns the final divide-and-pay payable amount with round-off discrepancy if applicable
 */
export const getDivideAndPayAmount = (amount: number, divideParts: number, payParts: number, purchase: Purchase) => {
    if (divideParts === 0) return 0;

    const payableAmount = (amount / divideParts) * payParts;
    return round(payableAmount, 2) + calculateRoundingDiscrepancy(payableAmount, purchase);
};
